import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53452084"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "ta-l" }
const _hoisted_3 = { class: "row-one-grid" }
const _hoisted_4 = { class: "departure-grid" }
const _hoisted_5 = { for: "from_stations" }
const _hoisted_6 = ["disabled", "aria-busy"]
const _hoisted_7 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { for: "favorite_btn" }
const _hoisted_12 = ["disabled", "value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "star"
}, [
  /*#__PURE__*/_createElementVNode("polygon", { points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { for: "to_stations" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "row-two-grid mt-5" }
const _hoisted_22 = { for: "date" }
const _hoisted_23 = { class: "ta-l di-b custom-label" }
const _hoisted_24 = ["data-tooltip"]
const _hoisted_25 = ["disabled", "aria-busy"]
const _hoisted_26 = { id: "results" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", null, null, -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { for: "switch" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "ml-5 ta-l date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JourneyComponent = _resolveComponent("JourneyComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("search.title")), 1),
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = ($event: any) => ($event.preventDefault()))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("search.station.departure")) + " ", 1),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChangeDeparture && _ctx.onChangeDeparture(...args))),
                disabled: !_ctx.isDepartureReady,
                "aria-busy": !_ctx.isDepartureReady,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.departure) = $event)),
                id: "from_stations"
              }, [
                _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("search.station.departureOption")), 1),
                (_ctx.departureStationsFavorites.length > 0)
                  ? (_openBlock(), _createElementBlock("optgroup", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departureStationsFavorites, (station) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: station.name,
                          value: station
                        }, _toDisplayString(_ctx.titleCaseGare(station.name)), 9, _hoisted_9))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departureStationsNotFavorite, (station) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: station.name,
                    value: station
                  }, _toDisplayString(_ctx.titleCaseGare(station.name)), 9, _hoisted_10))
                }), 128))
              ], 40, _hoisted_6), [
                [_vModelSelect, _ctx.departure]
              ])
            ]),
            _createElementVNode("label", _hoisted_11, [
              _createTextVNode(" ​ "),
              _createElementVNode("button", {
                disabled: !_ctx.isSearchReadyToStart,
                id: "favorite_btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFavorite(_ctx.departure))),
                value: _ctx.departure,
                class: _normalizeClass({ selected: _ctx.departure.favorite })
              }, _hoisted_14, 10, _hoisted_12)
            ])
          ]),
          _createElementVNode("label", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.$t("search.station.arrival")) + " ", 1),
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeArrival())),
              disabled: !_ctx.isArrivalReady,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.arrival) = $event)),
              id: "to_stations"
            }, [
              _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t("search.station.arrivalOption")), 1),
              (_ctx.arrivalStationsFavorites.length > 0)
                ? (_openBlock(), _createElementBlock("optgroup", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrivalStationsFavorites, (station) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: station.name,
                        value: station
                      }, _toDisplayString(_ctx.titleCaseGare(station.name)), 9, _hoisted_19))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrivalStationsNotFavorite, (station) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: station.name,
                  value: station
                }, _toDisplayString(_ctx.titleCaseGare(station.name)), 9, _hoisted_20))
              }), 128))
            ], 40, _hoisted_16), [
              [_vModelSelect, _ctx.arrival]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.$t("search.fromAt")) + " ", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "date",
              name: "date",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.from_date) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.from_date]
            ])
          ]),
          _createElementVNode("label", null, [
            _createElementVNode("small", _hoisted_23, [
              _createTextVNode(_toDisplayString(_ctx.$t("search.lastUpdate.label")) + " ", 1),
              _createElementVNode("em", {
                "data-tooltip": 
                _ctx.lastUpdateDataset ? _ctx.lastUpdateDataset.format('LLL') : null
              
              }, _toDisplayString(_ctx.humanizeDateDiff(_ctx.lastUpdateDataset) ||
                _ctx.$t("search.lastUpdate.notAvailable")), 9, _hoisted_24)
            ]),
            _createElementVNode("button", {
              disabled: !_ctx.isSearchReadyToStart,
              "aria-busy": _ctx.isSearchLoading,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch && _ctx.onClickSearch(...args))),
              class: "mt-1"
            }, _toDisplayString(_ctx.isSearchLoading ? "" : _ctx.$t("search.station.startSearch")), 9, _hoisted_25)
          ])
        ])
      ], 32)
    ]),
    _createElementVNode("section", _hoisted_26, [
      (_ctx.isSearchLoading)
        ? (_openBlock(), _createElementBlock("article", _hoisted_27, [
            _hoisted_28,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("search.station.startSearch")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSearchReady)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            false
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "switch",
                      name: "switch",
                      role: "switch",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showOnlyAvailableJourneys) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.showOnlyAvailableJourneys]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("result.showNotAvailableJourneys")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          Object.keys(_ctx.journeysFiltered(_ctx.showOnlyAvailableJourneys)).length === 0
        )
              ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                  _createElementVNode("article", null, _toDisplayString(_ctx.$t("result.noJourneyAvailable")), 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journeysFiltered(_ctx.showOnlyAvailableJourneys), (journeys, date) => {
              return (_openBlock(), _createElementBlock("section", { key: date }, [
                (journeys.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.humanizeDate(date)), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(journeys, (journey) => {
                  return (_openBlock(), _createBlock(_component_JourneyComponent, {
                    key: journey.id,
                    journey: journey
                  }, null, 8, ["journey"]))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}